module.exports = __webpack_public_path__ + "assets/img/welcome.29a7ebbb.png";